import { rootApi } from '../rootApi';

export const proformaInvoiceApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getProformaCustomers: builder.query({
            query: ({ searchText, rowCount = 50 } = {}) => ({
                url: 'v1/proformainvoice/getcustomers',
                method: 'GET',
                params: {
                    ...(searchText ? { searchText } : {}),
                    rowCount
                }
            }),
            transformResponse: (response) => response?.data ?? [],
            providesTags: ['ProformaCustomers']
        }),
        getProformaInvoiceList: builder.query({
            query: ({ PageNumber = 1, PageSize = 20 } = {}) => ({
                url: 'v1/proformainvoice/getlist',
                method: 'GET',
                params: { PageNumber, PageSize }
            }),
            providesTags: ['ProformaInvoiceList']
        }),
        getProformaInvoiceDetail: builder.query({
            query: ({ proformaId }) => ({
                url: 'v1/proformainvoice/getdetail',
                method: 'GET',
                params: { proformaId }
            }),
            providesTags: (result, error, arg) => [{ type: 'ProformaInvoiceDetail', id: arg?.proformaId }]
        }),
        upsertProformaInvoice: builder.mutation({
            query: (data) => ({
                url: 'v1/proformainvoice/upsert',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['ProformaInvoiceList', 'ProformaInvoiceDetail']
        }),
        getProformaLaborDropdown: builder.query({
            query: ({ languageId, chassisNo, searchText, pageSize = 20 } = {}) => ({
                url: 'v1/proformainvoice/getlabordropdown',
                method: 'GET',
                params: {
                    languageId,
                    ...(chassisNo ? { chassisNo } : {}),
                    ...(searchText ? { searchText } : {}),
                    pageSize
                }
            }),
            transformResponse: (response) => response?.data ?? []
        }),
        getProformaPartList: builder.query({
            query: ({ languageId = 2, partCode, partName, pageSize = 50 } = {}) => ({
                url: 'v1/proformainvoice/getpartlist',
                method: 'GET',
                params: {
                    languageId,
                    ...(partCode ? { partCode } : {}),
                    ...(partName ? { partName } : {}),
                    pageSize
                }
            }),
            transformResponse: (response) => response?.data ?? []
        })
    })
});

export const {
    useGetProformaCustomersQuery,
    useGetProformaInvoiceListQuery,
    useGetProformaInvoiceDetailQuery,
    useLazyGetProformaInvoiceDetailQuery,
    useUpsertProformaInvoiceMutation,
    useGetProformaLaborDropdownQuery,
    useLazyGetProformaLaborDropdownQuery,
    useGetProformaPartListQuery,
    useLazyGetProformaPartListQuery
} = proformaInvoiceApi;
